import React from 'react';
import { isSaaS } from 'utils/isSaaS';
import { Forbidden, InternalServerError, NotFound, WorksInProgress } from './components';
import { EStatuses, IStatus } from './types';

const Status = ({ status, ...props }: IStatus) => {
  const isSaas = isSaaS();

  switch (status) {
    case EStatuses.Forbidden:
      return <Forbidden isSaas={isSaas} {...props} />;
    case EStatuses.NotFound:
      return <NotFound isSaas={isSaas} {...props} />;
    case EStatuses.InternalServerError:
      return <InternalServerError isSaas={isSaas} {...props} />;
    case EStatuses.WorksInProgress:
      return <WorksInProgress isSaas={isSaas} {...props} />;
    default:
      return <Forbidden isSaas={isSaas} {...props} />;
  }
};

export default Status;
